import {createByWorkSpace} from '@/api/ContrAgentRpcClient';
import store from '@/store';
export default {
    namespaced: true,
    state: {
        mode: 'ws',
    },
    getters: {
        getClient: state => () => {
            if('ws' === state.mode){
                return createByWorkSpace(store.getters['workspace/ID_WORK_SPACE']);
            }
        },
    },
}